module.exports = "/images/ny-street-12.jpg";